import api from '@/lib/axios'

// ─── Annuaire des collègues ──────────────────────────────────────────────────
// `GET /users/directory` est accessible à tout utilisateur connecté et ne renvoie
// que des champs minimaux (entité courante, comptes actifs). À utiliser pour les
// sélecteurs (réunions, chat, tickets, projets, RH) — pas `GET /users` (admin).

export interface DirectoryUser {
  id: string
  firstName: string
  lastName: string
  email: string
  avatarUrl?: string | null
}

export interface DirectoryParams {
  search?: string
  limit?: number
}

export const usersApi = {
  directory: (params: DirectoryParams = {}) =>
    api
      .get<{ data: { items: DirectoryUser[] } }>('/users/directory', { params })
      .then((r) => r.data?.data?.items ?? []),
}
